import { fetchSettings } from './resources/settings.js';
import { fetchSectionTree } from './resources/sections.js';

const LOADERS = [
    fetchSettings,
    fetchSectionTree,
];

export const loadAppContext = () => Promise.all(LOADERS.map((loader) => loader()));
